import { createAction } from '@reduxjs/toolkit';
import * as types from './type';
import axiosAdapter from '../../../utils/Adapters';
import { CMSAPI_INDEX } from '../../../utils/CmsAPI';
import config from '../../../config';
import { isExternalURL } from '../../../utils/Helper';

const reset = createAction(types.ACTION_RESET);
const requestFetch = createAction(types.ACTION_REQUEST);
const receiveSuccess = createAction(types.ACTION_SUCCESS);
const receiveError = createAction(types.ACTION_ERROR);

const messageError = (error) => {
  const message =
    ((((error || {}).response || {}).data || {}).error || {}).message || error.message;
  return message;
};

const resetStoryItems = () => {
  return (dispatch) => {
    dispatch(reset());
  };
};

const fetchData = (locale, mainCate, keyword, offset, max, sortBy) => {
  const storyQueryObj = {};
  storyQueryObj.prefixPath = config.lscsPath;
  storyQueryObj.projectName = 'designinspireV2';
  storyQueryObj.max = max;
  storyQueryObj.sortBy = sortBy;
  storyQueryObj.start = offset;
  storyQueryObj.enableDate = false;
  storyQueryObj.q =
    '(displayStatus:online)%20AND%20(TeamSite/Templating/DCR/Type:=%22Designer Story/Story Items%22)' +
    (mainCate !== '*'
      ? '%20AND%20((mainCategory:' + mainCate + ')%20OR%20(otherCategories:' + mainCate + '))'
      : '') +
    (keyword !== ''
      ? '%20AND%20((storyTitle_' +
        locale +
        ':' +
        keyword.toLowerCase() +
        ')%20OR%20(companyName_' +
        locale +
        ':' +
        keyword.toLowerCase() +
        ')%20OR%20(keyword_' +
        locale +
        ':' +
        keyword +
        '))'
      : '');
  const url = CMSAPI_INDEX(storyQueryObj);

  return axiosAdapter({
    url,
  });
};

const massageData = (response, offset) => {
  const responseData = response.data;
  const data = responseData.result.assets;
  const totalCount = !data ? 0 : responseData.total;
  const languages = ['en', 'tc', 'sc'];
  const storyCollection = { en: [], tc: [], sc: [], max: totalCount, start: offset };

  if (!data) {
    return { ...storyCollection, status: 'failed' };
  }

  languages.map((lang) => {
    if (
      responseData.included > 0 &&
      Array.isArray(responseData.result.assets) &&
      responseData.result.assets.length > 0
    ) {
      responseData.result.assets.map((story) => {
        const reference = story['metadata'];
        if (reference['storyTitle_' + lang]) {
          const item = {};
          /* item.title = reference['storyTitle_' + lang]; */
          item.title = story['content']['content'][lang]['coreInfo']['storyTitle'];
          /* item.company = reference['companyName_' + lang]; */
          item.company = story['content']['content'][lang]['coreInfo']['companyName'];
          item.cover = reference['storyCover'];
          item.mainCate = reference['mainCategory_' + lang];
          item.type = reference['storyType_' + lang];
          item.id = reference['storyID'];
          switch (item.type) {
            case 'storyPage':
              const targetURL = reference['storyURL_' + lang];
              item.url = isExternalURL(targetURL)
                ? targetURL
                : config.routePathTo + '/' + lang + '/story/details/' + targetURL;
              break;
            case 'videoOnly':
              item.url = reference['storyURL_' + lang];
              break;
            case 'fileDownload':
              item.url = reference['storyURL_' + lang];
              break;
          }

          storyCollection[lang].push(item);
        }
      });
    }
  });

  return { ...storyCollection, status: 'ready' };
};

const getStoryItems = ({ locale, mainCate, keyword, offset, max, sortBy }) => {
  return (dispatch) => {
    dispatch(requestFetch({ locale, mainCate, keyword, offset, max, sortBy }));
    return fetchData(locale, mainCate, keyword, offset, max, sortBy)
      .then((response) => massageData(response, offset))
      .then((data) => dispatch(receiveSuccess(data)))
      .catch((error) => {
        const message = messageError(error);
        dispatch(receiveError(message));
      });
  };
};

export { getStoryItems, resetStoryItems };
